import React, { Component } from 'react';
// import SiSideNav from 'components/sidenav';
import TopHeader from '../distributorHome/header';
import RemoteAccessform from '../views/RemoteAccessform';



class RemoteAccess2 extends Component {

    constructor(props) {
        super(props);
    }

    openModal = () => {
        alert("modal opened");
    }

    render() {
        return (
            <div className="root">
                <TopHeader history={this.props.history} />
                {/* <SiSideNav history={this.props.history} selected="dashboard" /> */}
                <RemoteAccessform openModal={this.openModal} />
                {/* <SupportRemoteAccess/>
                <RemoteAccessform/> */}
            </div>
        )
    }
}

export default RemoteAccess2;